import * as updateName  from './updateName'
import * as updatePassword  from './updatePassword'
import * as userDetails from './userDetails'
export default {
    ...updateName,
    ...updatePassword,
    ...userDetails
} 